var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionInfoTip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0C2.685 0 0 2.685 0 6C0 9.315 2.685 12 6 12C9.315 12 12 9.315 12 6C12 2.685 9.315 0 6 0ZM6.75 9.75H5.25V8.25H6.75V9.75ZM8.1975 4.86C8.0925 5.1 7.935 5.34 7.7325 5.5875L6.9375 6.6225C6.8475 6.735 6.7575 6.84 6.7275 6.9375C6.6975 7.035 6.66 7.1625 6.66 7.3275V7.5H5.34V6.66C5.34 6.66 5.3775 6.2775 5.4975 6.1275L6.3 5.0475C6.465 4.8525 6.5625 4.68 6.63 4.5375C6.6975 4.395 6.72 4.2525 6.72 4.1025C6.72 3.8775 6.645 3.69 6.51 3.54C6.375 3.3975 6.18 3.33 5.94 3.33C5.6925 3.33 5.4975 3.405 5.355 3.5475C5.2125 3.69 5.1075 3.8925 5.055 4.155C5.0325 4.2375 4.98 4.2675 4.905 4.26L3.63 4.0725C3.54 4.065 3.51 4.0125 3.525 3.93C3.615 3.315 3.87 2.8275 4.2975 2.475C4.725 2.115 5.2875 1.935 5.985 1.935C6.3375 1.935 6.66 1.9875 6.9525 2.1C7.245 2.2125 7.4925 2.355 7.7025 2.5425C7.9125 2.73 8.07 2.955 8.19 3.21C8.3025 3.4725 8.355 3.75 8.355 4.05C8.355 4.35 8.3025 4.6125 8.1975 4.86Z",
    fill: "#8F95B2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionInfoTip);
export default __webpack_public_path__ + "static/media/question-info-tip.c0f92fa3.svg";
export { ForwardRef as ReactComponent };